import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { listConcepts } from './api';
import ConceptWorkspace from './ConceptWorkspace';
import SlaBadge from './SlaBadge';

export default function ReviewsQueue() {
  const [activeId, setActiveId] = useState(null);
  const [tab, setTab] = useState('pending'); // pending = awaiting me, decided = my history
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['training-reviews-queue', tab],
    queryFn: () => listConcepts(tab === 'pending' ? { mine: 1 } : { reviewed: 1 }),
    enabled: !activeId,
  });

  if (activeId) return <ConceptWorkspace conceptId={activeId} onBack={() => setActiveId(null)} />;

  const rows = data?.concepts || [];
  const TabBtn = ({ id, label }) => (
    <button
      onClick={() => setTab(id)}
      className={`text-xs px-3 py-1.5 rounded-full border ${
        tab === id ? 'bg-blue-600 text-white border-blue-600' : 'border-gray-300 text-gray-500'
      }`}
    >
      {label}
    </button>
  );

  return (
    <div>
      <div className="flex items-center gap-2 mb-3">
        <h2 className="text-lg font-semibold mr-2">My reviews</h2>
        <TabBtn id="pending" label="Awaiting you" />
        <TabBtn id="decided" label="Decided by you" />
      </div>

      {isLoading && <div className="text-sm text-gray-500">Loading…</div>}
      {isError && <div className="text-sm text-red-500">Could not load reviews{error?.message ? `: ${error.message}` : ''}.</div>}
      {!isLoading && !isError && rows.length === 0 && (
        <div className="text-sm text-gray-500">
          {tab === 'pending' ? 'Nothing awaiting your review.' : "You haven't decided any reviews yet."}
        </div>
      )}
      {rows.map((c) => (
        <button
          key={c.id}
          onClick={() => setActiveId(c.id)}
          className="block w-full text-left border border-gray-200 dark:border-gray-700 rounded-xl p-3 mb-2 hover:shadow-md"
        >
          <div className="flex items-center justify-between gap-2">
            <div className="text-sm font-semibold">{c.title}</div>
            {tab === 'pending' && <SlaBadge dueAt={c.sla_due_at} breachedAt={c.sla_breached_at} />}
          </div>
          <div className="text-xs text-gray-500">
            {String(c.status).replace(/_/g, ' ')} · {c.program}
          </div>
        </button>
      ))}
    </div>
  );
}
